import { Controller } from "stimulus";

export default class extends Controller {
  static get values() {
    return { resource: String };
  }

  update(event) {
    const count = this._selectionLength(event.detail.value);

    this._toggleDisplayNone(count);
    this.element.innerText = `You have selected ${count} ${this.resourceValue}.`;
  }

  _selectionLength(selection) {
    return selection === "" ? 0 : selection.split(",").length;
  }

  _toggleDisplayNone(count) {
    if (count === 0) {
      this.element.classList.add("dn");
    } else {
      this.element.classList.remove("dn");
    }
  }
}
